module.exports = __webpack_public_path__ + "img/waikiki-beach.dc9be10d.jpg";